import React, { useState, useEffect, useMemo } from 'react';
import { Row, Col, Button } from 'reactstrap';
import { useTranslation } from "react-i18next";
import DataTable from 'react-data-table-component';
import axios from 'axios';
import bag from "../../../Assets/Images/profile/defaultProfile.jpg";
import { ToastContainer, toast } from 'react-toastify';
import { CheckCircleOutlined } from '@ant-design/icons';
import { CloseCircleOutlined } from '@ant-design/icons';
import { useNavigate } from "react-router-dom";
import CompLoaderBtn from '../../Common/CompLoaderBtn';
import CompLoaderDt from '../../Common/CompLoaderDt';

function CompDtDefaultSystemPosProvider() {
    const { t } = useTranslation();
    const [componentId] = useState('compDtDefaultSystemPosProvider');
    const [data, setData] = useState(null);

    const navigate = useNavigate();

    const [apiCalled, setApiCalled] = useState(false);
    const [apiCalledBy, setApiCalledBy] = useState('');

    const [pageNumber, setPageNumber] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [sort, setSort] = useState('createDate,DESC');
    const [paginationRowsPerPageOptions] = useState([1, 5, 10, 25, 50, 100]);
    const [totalRows, setTotalRows] = useState(0);

    const callPricingDetails = (pricingData) => {
        setApiCalled(true);
        setApiCalledBy(pricingData?.id);
        let requestBody = {

        };
        const timeout = setTimeout(() => {
            let message = t('product.common-notification.will-be-develop');
            toast.warning(message, { autoClose: 1000 });
            setApiCalled(false);
            let redirectUrl = '/finance/pricing/market-place/' + pricingData?.code;
            //window.location.href = redirectUrl;
            //navigate(redirectUrl);
        }, 500);
    };

    React.useMemo(() => {
        if (sessionStorage.getItem("currentSession") !== null && sessionStorage.getItem("currentSession")?.bearerToken !== '') {
            let currentSession = sessionStorage.getItem("currentSession");
            axios.defaults.headers.common["X-User-Language"] = t('language')?.toUpperCase();
            axios.defaults.headers.common["Authorization"] = currentSession !== null ? JSON.parse(currentSession)?.bearerToken : null;
            let ApiGateway = process.env.REACT_APP_API_URL;
            axios.get(ApiGateway + '/finance/back-office/pos-provider/default-system-pos-provider/find-and-get')
                .then(response => {
                    if (response.data?.isSucceed === true) {
                        let data_payload = {};
                        let content = [];
                        content.push(response.data?.payload);
                        data_payload.content = content;
                        setData(data_payload);
                    }

                })
                .catch(error => {
                    console.error(error);
                });
        }
    }, [t]);

    const [deleteModal, setDeleteModal] = useState(false);
    const [recordId, setRecordId] = useState(false);

    const onGoToItemDetails = props => {
        //history.push('/product/' + props);
        //dispatch(mpMyCashDeskListApi(props));
    };

    const onBtnDeleteItem = props => {
        let message = 'Prohibited action!';
        toast.error(message, { autoClose: 1000 });
        console.log(props);
        setRecordId(props);
        //setDeleteModal(true);
    };

    const handleDeleteTask = () => {
        if (recordId) {
            //dispatch(mpMyCashDeskDeleteByIdApi({ cashDeskId: recordId }));
            //setDeleteModal(false);
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
            //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
        }
    };


    useEffect(() => {
        //dispatch(mpMyCashDeskListApi(pageNumber, pageSize, sort));
    }, []);


    const handlePageChange = page => {
        setPageNumber(page - 1);
        //dispatch(mpMyCashDeskListApi(page - 1, pageSize, sort));
    }

    const handlePerRowsChange = async (newPerPage, page) => {
        setPageSize(newPerPage);
        //dispatch(mpMyCashDeskListApi(0, newPerPage, sort));
    }

    const columns = [
        {
            name: <span className='font-weight-bold fs-13'>{t('components.finance.pos-provider.default-system-pos-provider.comp-dt-pos.dt.th.provider')}</span>,
            selector: row =>
                <div className="d-flex align-items-center mt-2">
                    <div className="flex-shrink-0 mb-2">
                        <i className={"faindex fa fa-tag"}></i> &nbsp;
                    </div>
                    <div className="flex-grow-1 ms-2">
                        <h6 className="mb-1"><span title={row?.provider?.label}>{row?.provider?.label}</span></h6>
                        <p className="text-muted mb-2"><span title={row?.provider?.value}>{row?.provider?.value}</span></p>
                    </div>
                    <div className="flex-shrink-0">
                    </div>
                </div>
            ,
            sortable: false,
            maxWidth: "175px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.finance.pos-provider.default-system-pos-provider.comp-dt-pos.dt.th.baseUrl')}</span>,
            selector: row => <span title={row?.baseUrl}>{row?.baseUrl}</span>,
            sortable: false,
            maxWidth: "185px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.finance.pos-provider.default-system-pos-provider.comp-dt-pos.dt.th.iyzico-api-key')}</span>,
            selector: row => <span title={row?.iyzicoApiKey}>{row?.iyzicoApiKey}</span>,
            sortable: false,

            maxWidth: "325px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.finance.pos-provider.default-system-pos-provider.comp-dt-pos.dt.th.iyzico-secret-key')}</span>,
            selector: row => <span title={row?.iyzicoSecretKey}>{row?.iyzicoSecretKey}</span>,
            sortable: false,
            maxWidth: "325px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.finance.pos-provider.default-system-pos-provider.comp-dt-pos.dt.th.enabled')}</span>,
            selector: row => <span title={row?.enabled}>{row?.enabled===true?'true':'false'}</span>,
            sortable: false,
            maxWidth: "135px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.finance.pos-provider.default-system-pos-provider.comp-dt-pos.dt.th.default-system-pos-provider')}</span>,
            selector: row => <span title={row?.defaultSystemPosProvider}>{row?.defaultSystemPosProvider===true?'true':'false'}</span>,
            sortable: false,
            maxWidth: "135px"
        },
        {
            name: <span className='font-weight-bold fs-13'>{t('components.finance.pos-provider.default-system-pos-provider.comp-dt-pos.dt.th.order')}</span>,
            selector: row => <span title={row?.order}>{row?.order}</span>,
            sortable: false,
            maxWidth: "135px"
        },
    ];

    const [pending, setPending] = useState(true);
    const [rows, setRows] = useState([]);
    useEffect(() => {
        const timeout = setTimeout(() => {
            setRows(data?.content);
            setPending(false);
            setTotalRows(data?.totalElements);
        }, 0);
        return () => clearTimeout(timeout);
    }, [data]);

    return (
        <React.Fragment>
            <ToastContainer />
            {data ? ((
                <DataTable
                    id={componentId}
                    columns={columns}
                    data={rows}
                    pagination={false}
                    paginationServer
                    onPageChange={page => setPageNumber(page)}
                    paginationPerPage={pageSize}
                    paginationTotalRows={totalRows}
                    onChangePage={handlePageChange}
                    onChangeRowsPerPage={handlePerRowsChange}
                    progressPending={pending}
                    noDataComponent={t('data-table.label.no-data')}
                    paginationRowsPerPageOptions={paginationRowsPerPageOptions}
                    paginationComponentOptions={{
                        rowsPerPageText: t('data-table.label.rows-per-page'),
                        rangeSeparatorText: t('data-table.label.out-of'),
                    }}
                />
            )) : (
                <Row>
                    <Col className={"col-md-12 text-center"}>
                        <CompLoaderDt />
                    </Col>
                </Row>
            )}
        </React.Fragment>
    );
}
export default CompDtDefaultSystemPosProvider;